import React from 'react';
import PropTypes from 'prop-types';
import { TopToolbar, ListButton } from 'react-admin';

const SurveyQuestionActions = ({ basePath, data }) => (
  <TopToolbar>
    <ListButton basePath={basePath} record={data} />
  </TopToolbar>
);

SurveyQuestionActions.propTypes = {
  basePath: PropTypes.string,
  data: PropTypes.shape({}),
};

SurveyQuestionActions.defaultProps = {
  basePath: '',
  data: {},
};

export default SurveyQuestionActions;
